import React, { useState, useEffect } from 'react'

import Tooltip from '../Tooltip'
import Close from './Close'

import * as S from './styled'

const VirtualAssistant = ({ isMobile, virtualAssistantUrl, brand, opened }) => {
  const [showChat, setShowChat] = useState(false)
  const [close, setClose] = useState(true);

  const startChat = () => {
    setShowChat(true)
  }
  const hideChat = () => {
    setShowChat(false)
  }

  useEffect(() => {
    const showTooltip = !sessionStorage?.getItem('tooltip.chatbot');
    let timeoutId = setTimeout(() => {
      if (showTooltip) {
        setClose(false);
        timeoutId = setTimeout(() => {
          setClose(true);
        }, 7000);
      }
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, []);

  const handleClose = () => {
    setClose(true);
    sessionStorage.setItem('tooltip.chatbot', 'true');
  };

  return (
    <>
      {isMobile ? (
         <>
            <S.VirtualAssistant
              id="virtual-assistant-cms"
              src={virtualAssistantUrl + '?brand=' + brand + '&mobile=true'}              
              scrolling="no"
              sandbox="allow-scripts allow-same-origin allow-top-navigation allow-popups"
              target="_blank"
              allowtransparency="true"
              className={showChat ? '' : 'close-animation'}
              style={{
                display: showChat ? '' : 'none',
                position: 'fixed',
                inset: 'auto auto 0 auto',
                height: '100vh',
                width: '100%',
                zIndex: 1100,
                frameborder: 0,
                overflow: 'hidden',
                backgroundColor: 'white',
              }}
            />
            {!close & !showChat && <Tooltip onClose={handleClose} text='Dúvidas de **agendamento**, **exames**, ou **convênios**?' />}
            <S.MaximizeVirtualAssistant showChat={showChat}>
              {!showChat ? (
                <S.MaximizeButton className="btn" onClick={() => startChat()}>
                  <S.VirtualAssistantIcon src='https://bkt-sa-east-1-cms-2-assets-prd.s3.sa-east-1.amazonaws.com/image/virtual-assistant-icon.png' />
                </S.MaximizeButton>
              ) : (
                <S.MinimizeButton className="btn" onClick={() => hideChat()}>
                  <Close />
                </S.MinimizeButton>
              )}
            </S.MaximizeVirtualAssistant>
          </>          
        ) : (
          <>
            <S.VirtualAssistant
              id="virtual-assistant-cms"
              src={virtualAssistantUrl + '?brand=' + brand}
              scrolling="no"
              sandbox="allow-scripts allow-same-origin allow-top-navigation allow-popups allow-forms"
              target="_blank"
              allowtransparency="true"
              className={opened ? '' : 'close-animation'}
              style={{
                display: showChat ? '' : 'none',
                position: 'fixed',
                inset: 'auto 90px 40px auto',
                height: '432px',
                width: '367px',
                zIndex: 10,
                frameborder: 0,
                overflow: 'hidden',
                boxShadow: 'rgb(22 22 22 / 4%) 0px 4px 4px, rgb(22 22 22 / 8%) 0px 8px 24px',
              }}
            />
            {!close & !showChat && <Tooltip onClose={handleClose} text='Dúvidas de **agendamento**, **exames**, ou **convênios**?' />}
            <S.MaximizeVirtualAssistant showChat={showChat}>
              {!showChat ? (
                <S.MaximizeButton className="btn" onClick={() => startChat()}>
                  <S.VirtualAssistantIcon src='https://bkt-sa-east-1-cms-2-assets-prd.s3.sa-east-1.amazonaws.com/image/virtual-assistant-icon.png' />
                </S.MaximizeButton>
              ) : (
                <S.MinimizeButton className="btn" onClick={() => hideChat()}>
                  <Close />
                </S.MinimizeButton>
              )}
            </S.MaximizeVirtualAssistant>          
          </>
          
        )
      }
    </>
  )
}

export default VirtualAssistant
